import { render, staticRenderFns } from "./cateAdd.vue?vue&type=template&id=bd4f34ea&scoped=true&"
import script from "./cateAdd.vue?vue&type=script&lang=js&"
export * from "./cateAdd.vue?vue&type=script&lang=js&"
import style0 from "./cateAdd.vue?vue&type=style&index=0&id=bd4f34ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4f34ea",
  null
  
)

export default component.exports